export class ReleaseItemsAuditLogFilter {
  companyCode: string;
  cropYear: number;
  itemNo: string;
  orderNo: string;
  changeQty: number;
  changeQtyAction: string;
  account: string;
  accountName: string;
  productName: string;
  marketingBrand: string;
  releases: string;
  branchPlant: string;
  requestType: string;
  seedSize: string;
  packageSize: string;
  technology: string;
  treatment: string;
  productLine: string;
  explanation: string;
  dotTransactionID: string;
  fromDate: any;
  toDate: any;
  evolveAccountRestriction: boolean;
  userId: string;
  includeChangeQtyZero: boolean;
  city: string;
  erpOrderNumber: string;
}
